import React from 'react';
import { PDFViewer } from '@react-pdf/renderer';
import { CertificatePDFData } from './types';
import CertificatePDFDocument from './PDFTemplate/index';

interface PreviewModalProps {
  certificate: CertificatePDFData;
  isOpen: boolean;
  onClose: () => void;
}

const PreviewModal: React.FC<PreviewModalProps> = ({ certificate, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      zIndex: 1000,
      display: 'flex',
      flexDirection: 'column'
    }}>
      
      <div style={{
        backgroundColor: 'white',
        padding: '1rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid #e5e7eb'
      }}>
        <h2 style={{ margin: 0, color: '#1e40af' }}>
          Preview do Certificado #{certificate.id}
        </h2>
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '1.5rem',
            cursor: 'pointer',
            color: '#6b7280',
            padding: '0.5rem'
          }}
        >
          ✕
        </button>
      </div>

      
      <div style={{ flex: 1, backgroundColor: '#f3f4f6', position: 'relative' }}>
        
        <PDFViewer 
          style={{ width: '100%', height: '100%' }}
          showToolbar={false}
        >
          <CertificatePDFDocument certificate={certificate} />
        </PDFViewer>
      </div>
    </div>
  );
};

export default PreviewModal; 